<template>
  <div class="result-type-wrapper" :class="classes">
    <Icon class="result-icon succ" v-if="state == 'success'"></Icon>
    <Icon class="result-icon storing" v-if="state == 'storing'"></Icon>
    <Icon class="result-icon fail" v-if="state == 'fail'"></Icon>
    <p class="result-title">{{ title }}</p>
    <p class="opera-tips" v-html="tips"></p>
    <slot></slot>
  </div>
</template>

<script>
import themeMixins from '@mixins/officialStore/themeMixins';
export default {
  mixins: [themeMixins],
  props: ['title', 'tips', 'state'],
  computed: {
    states() {
      return [this.state];
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';
.result-type-wrapper {
  display: inline-block;
  margin-top: 52px;
  width: 100%;
}
.result-icon {
  margin: 0 auto;
  background-size: 100% 100%;
  &.succ {
    // 这里
    background-repeat: no-repeat;
    @psetbg ('result-succ-ico.png');
  }
  &.fail {
    // 这里
    background-repeat: no-repeat;
    @psetbg ('result-fail-ico.png');
  }
  &.storing {
    // 这里
    background-repeat: no-repeat;
    @psetbg ('result-storing-ico.png');
  }
}
.result-title {
  margin-top: 51px;
  margin-bottom: 17px;
  width: 100%;
  text-align: center;
  font-size: 72px;
  color: var(--result-title);
}
.opera-tips {
  margin: 0 auto 26px;
  width: 679px;
  line-height: 30px;
  text-align: center;
  font-size: 22px;
  color: var(--result-tip);
  &.look-more {
    cursor: pointer;
    color: var(--result-look-more);
  }
  &.mb0 {
    margin-bottom: 0;
  }
}
.order-info-container {
  box-sizing: border-box;
  margin: 0 auto;
  padding: 0 30px;
  width: 679px;
  background: var(--result-order-bg);
  font-size: 30px;
  color: var(--result-order-text);
}
@media screen and (orientation: landscape) {
  .result-type-wrapper {
    margin-top: 72px;
  }
  .result-title {
    font-size: 60px;
  }
}
</style>
